module.exports = __webpack_public_path__ + "static/media/Colette Straight King Headboard - 180 cm_Teal.dcb9ad40.png";